import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  width: 100%;
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  @media only screen and (max-width: 1000px) {
    flex-direction: column;
  }
`;

export const TitleContainer = styled.div`
  > :not(:last-child) {
    margin-right: 30px;
  }
`;

export const PageTitle = styled.span`
  align-self: flex-start;
  font-family: BiotifSemiBold;
  font-size: 28px;
  padding-bottom: 10px;
`;

export const HeaderRightItems = styled.div`
  display: flex;
  min-width: max-content;
  justify-content: space-between;

  & > *:not(:last-child) {
    margin-right: 8px;
  }

  @media only screen and (max-width: 1000px) {
    flex-direction: column;
    margin: 0;

    & > *:not(:last-child) {
      margin: 4px 0;
    }
  }
`;

export const TopContent = styled.div`
  gap: 24px;
  width: 100%;
  display: flex;
  margin-top: 24px;
  @media only screen and (max-width: 1000px) {
    flex-direction: column;
  }
`;

export const DefaultContainer = styled.div`
  margin-top: 24px;
  background-color: white;
  border-radius: 4px;
  padding: 8px 16px 16px 16px;
  height: min(40vh);
  @media only screen and (max-width: 1000px) {
    width: 100%;
  }
`;

export const TableContent = styled(DefaultContainer)`
  padding-top: 32px;
  height: auto;
`;

export const DetailsContainer = styled(DefaultContainer)`
  min-width: 38%;
`;

export const NotificationsContainer = styled(DefaultContainer)`
  width: 100%;
`;

export const ChartContainer = styled(DefaultContainer)`
  min-width: 34%;
  overflow: hidden;
`;

export const CardTitle = styled.h3``;
